import { render, staticRenderFns } from "./jiceng.vue?vue&type=template&id=842e25e2&scoped=true&"
import script from "./jiceng.vue?vue&type=script&lang=js&"
export * from "./jiceng.vue?vue&type=script&lang=js&"
import style0 from "./jiceng.vue?vue&type=style&index=0&id=842e25e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842e25e2",
  null
  
)

export default component.exports